export default "__VITE_ASSET__3094f7b0__"